// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { Params } from '@feathersjs/feathers'
import type { ClientApplication } from '../../client'
import type { Telegram, TelegramData, TelegramPatch, TelegramQuery, TelegramService } from './telegram.class'

export type { Telegram, TelegramData, TelegramPatch, TelegramQuery }

export type TelegramClientService = Pick<TelegramService<Params<TelegramQuery>>, (typeof telegramMethods)[number]>

export const telegramPath = 'telegram'

export const telegramMethods: Array<keyof TelegramService> = ['find', 'get', 'create', 'patch', 'remove']

export const telegramClient = (client: ClientApplication) => {
  const connection = client.get('connection')

  client.use(telegramPath, connection.service(telegramPath), {
    methods: telegramMethods
  })
}

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [telegramPath]: TelegramClientService
  }
}
